import type { TenantLookupDto } from './models';
import { RestService } from '@abp/ng.core';
import type { ListResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TenantLookupService {
  apiName = 'Default';
  

  getTenantLookup = () =>
    this.restService.request<any, ListResultDto<TenantLookupDto>>({
      method: 'GET',
      url: '/api/app/tenant-lookup/tenant-lookup',
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
